import { render, staticRenderFns } from "./reply-btn.vue?vue&type=template&id=0117c51c"
import script from "./reply-btn.vue?vue&type=script&lang=js"
export * from "./reply-btn.vue?vue&type=script&lang=js"
import style0 from "./reply-btn.vue?vue&type=style&index=0&id=0117c51c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports